import { render, staticRenderFns } from "./WitnessUserList.vue?vue&type=template&id=c9a6f598&"
import script from "./WitnessUserList.vue?vue&type=script&lang=js&"
export * from "./WitnessUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports